<div class="container">
    <h1 class="text-center mb-5">Privacy Policy & Terms of Use</h1>

    <!-- Privacy Policy Section -->
    <section>
        <h2 class="section-title">Privacy Policy</h2>
        <p><strong>Introduction:</strong> This Privacy Policy describes how <strong>Your Company Name</strong> ("we",
            "us", "our") collects, uses, and protects your data on our platform <a class="text-bold text-decoration-none"
                    href="https://mykadai.varnik.cloud/#/">MyKadai</a>.</p>

        <h5 class="text-bold">Data Collection</h5>
        <p>We collect personal data such as your name, email, phone number, and transaction details during sign-up or
            interactions with our Platform. Sensitive data like payment information is collected only with your
            consent.</p>

        <h5 class="text-bold">Usage</h5>
        <p>Your data helps us deliver services, process transactions, prevent fraud, and improve customer experience.
            You can opt out of marketing messages anytime.</p>

        <h5 class="text-bold">Sharing</h5>
        <p>We may share your data with our affiliates, partners, and service providers. Data may also be disclosed when
            required by law or government authority.</p>

        <h5 class="text-bold">Security</h5>
        <p>We use reasonable security practices to protect your information. However, internet transmission is not fully
            secure, and users are responsible for keeping login details confidential.</p>

        <h5 class="text-bold">Data Retention</h5>
        <p>We retain your data only as long as necessary for the purposes for which it was collected. You can request
            deletion by contacting our support team.</p>

        <h5 class="text-bold">Your Rights</h5>
        <p>You can access, update, or delete your personal data through your account settings or by contacting us.</p>
    </section>

    <!-- Terms & Conditions Section -->
    <section>
        <h2 class="section-title">Terms & Conditions</h2>

        <h5 class="text-bold">Acceptance of Terms</h5>
        <p>By using our Platform, you agree to be bound by our Terms of Use, Privacy Policy, and applicable laws.</p>

        <h5 class="text-bold">Eligibility</h5>
        <p>Only individuals above 18 years of age are eligible to use our services.</p>

        <h5 class="text-bold">Accuracy of Information</h5>
        <p>You must provide accurate and complete information during registration and transactions. We are not liable
            for any inaccuracies.</p>

        <h5 class="text-bold">Limitation of Liability</h5>
        <p>We are not responsible for any losses or damages arising from your use of the Platform. Use the Platform at
            your own risk.</p>

        <h5 class="text-bold">Changes to Terms</h5>
        <p>We may revise these terms at any time. Continued use of the Platform implies acceptance of the revised
            terms.</p>

        <p>

            This document is an electronic record in terms of Information Technology Act, 2000 and rules there under as
            applicable and the amended provisions pertaining to electronic records in various statutes as amended by the
            Information Technology Act, 2000. This electronic record is generated by a computer system and does not
            require any physical or digital signatures. This document is published in accordance with the provisions of
            Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 2011 that require publishing the
            rules and regulations, privacy policy and Terms of Use for access or usage of domain name <a class="text-decoration-none font-weight-bold"
                href="https://mykadai.varnik.cloud/#/">MyKadai</a>
            including the related mobile site and mobile application (hereinafter 3 referred to as “Platform”). The
            Platform is owned by
            <a class="text-danger text-decoration-none font-weight-bold" target="_blank"  href="https://varnik.cloud/#/">VarNik Systems Services Pvt Ltd </a>a company incorporated under the Companies
            Act, 1956 with its registered office at (Enter Address) (hereinafter referred to as "Platform Owner", “we”,
            “us”, “our”). Your use of the Platform and services and tools are governed by the following terms and
            conditions ("Terms of Use") as applicable to the Platform including the applicable policies which are
            incorporated herein by way of reference. If You transact on the Platform, You shall be subject to the
            policies that are applicable to the Platform for such transaction. By mere use of the Platform, You shall be
            contracting with the Platform Owner and these terms and conditions including the policies constitute Your
            binding obligations, with Platform Owner. These Terms of Use
            relate to your use of our website, goods (as applicable) or services (as applicable) (collectively,
            “Services”). Any terms and conditions proposed by You which are in addition to or which conflict with these
            Terms of Use are expressly rejected by the Platform Owner and shall be of no force or effect. These Terms of
            Use can be modified at any time without assigning any reason. It is your responsibility to periodically
            review these Terms of Use to stay informed of updates. For the purpose of these Terms of Use, wherever the
            context so requires "you", “your” or "user" shall mean any natural or legal person who has agreed to become
            a user/buyer on the Platform. ACCESSING, BROWSING OR OTHERWISE USING THE PLATFORM INDICATES YOUR AGREEMENT
            TO ALL THE TERMS AND CONDITIONS UNDER THESE TERMS OF USE, SO PLEASE READ THE TERMS OF USE CAREFULLY BEFORE
            PROCEEDING.
            The use of Platform and/or availing of our Services is subject to the following Terms of Use: To access and
            use the Services, you agree to provide true, accurate and complete information to us during and after
            registration, and you shall be responsible for all acts done through the use of your registered account on
            the Platform. Neither we nor any third parties provide any warranty or guarantee as to the accuracy,
            timeliness, performance, completeness or suitability of the information and materials offered on this
            website or through the Services, for any specific purpose. You acknowledge that such information and
            materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or
            errors to the fullest extent permitted by law. Your use of our Services and the Platform is solely and
            entirely at your own risk and discretion for which we shall not be liable to you in any manner. You are
            required to independently assess and ensure that the Services meet your requirements. The contents of the
            Platform and the Services are proprietary to us and are licensed to us.
            You will not have any authority to claim any intellectual property rights, title, or interest in its
            contents. The contents includes and is not limited to the design, layout, look and graphics. You acknowledge
            that unauthorized use of the Platform and/or the Services may lead to action against you as per these Terms
            of Use and/or applicable laws. You agree to pay us the charges associated with availing the Services. You
            agree not to use the Platform and/ or Services for any purpose that is unlawful, illegal or 4 forbidden by
            these Terms, or Indian or local laws that might apply to you. You agree and acknowledge that website and the
            Services may contain links to other third party websites. On accessing these links, you will be governed by
            the terms of use, privacy policy and such other policies of such third party websites. These links are
            provided for your convenience for provide further information. You understand that upon initiating a
            transaction for availing the Services you are entering into a legally binding and enforceable contract with
            the Platform Owner for the Services. You shall indemnify and hold harmless Platform Owner, its affiliates,
            group companies (as applicable) and their respective officers, directors, agents, and employees, from any
            claim or demand, or actions including reasonable attorneys’ fees, made by any third party or penalty imposed
            due to or arising out of Your breach of this Terms of Use, privacy Policy and other Policies, or Your
            violation of any law, rules or regulations or the rights (including infringement of intellectual property
            rights) of a third party. In no event will the Platform Owner be liable for any indirect, consequential,
            incidental, special or punitive damages,
            including without limitation damages for loss of profits or revenues, business interruption, loss of
            business opportunities, loss of data or loss of other economic interests, whether in contract, negligence,
            tort or otherwise, arising from the use of or inability to use the Services, however caused and whether
            arising in contract, tort, negligence, warranty or otherwise, exceed the amount paid by You for using the
            Services giving rise to the cause of action or Rupees One Hundred (Rs. 100) whichever is less
            Notwithstanding anything contained in these Terms of Use, the parties shall not be liable for any failure to
            perform an obligation under these Terms if performance is prevented or delayed by a force majeure event.
            These Terms and any dispute or claim relating to it, or its enforceability, shall be governed by and
            construed in accordance with the laws of India. All disputes arising out of or in connection with these
            Terms shall be subject to the exclusive jurisdiction of the courts in (Enter City and State) All concerns or
            communications relating to these Terms must be communicated to us using the contact information provided on
            this website.
        </p>

        <h5 class="text-bold mt-3">Shipping Policy</h5>
        <p>Processing Time: all orders are delivered within 2-3 business days. Orders are not shipped or delivered on
            weekends or
            holidays. If we are experiencing a high volume of orders, shipments may be delayed by a few days. Please
            allow additional days in transit for delivery. If there will be a significant delay in the shipment of your
            order, we will contact you via email or phone.
            Shipping Time Domestic Shipping: Orders will be delivered within 3 to 4 weeks from the date of order
            confirmation. Please note that delivery times may be affected by factors beyond our control, such as weather
            conditions, customs delays, and other unforeseen circumstances.</p>

        <h5 class="text-bold">Return and Refund policy</h5>
        <h6 class="text-bold">Returns</h6>
        <p>We have a 5-day return policy, which means you have 5 days after receiving your item to request a return.
            Once the return product is received it will be inspected and the return will be approved within 2 days</p>

        <h6 class="text-bold">Refunds</h6>
        <p>We will notify you once we’ve received and inspected your return, and let you know if the refund was approved
            or not. If approved, you’ll be automatically refunded on your original payment method within 10 business
            days. Please remember it can take some time for your bank or credit card company to process and post the
            refund too. If more than 15 business days have passed since we’ve approved your return, please contact us at
            <a href="mailto:support@varnik.cloud" class="text-decoration-none">
                support@varnik.cloud
            </a> / <a href="tel:9791396308" class="text-decoration-none">
                +91 97913 96308
            </a></p>

    </section>
</div>
<footer class="bg-dark text-light py-5">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 mb-4 mb-lg-0">
                <h5 class="text-uppercase mb-4">My Kadai</h5>
                <p class="small text-white">Your trendsetting destination for easy shopping and service ordering.
                    Experience the convenience of a single app for all your needs.</p>
                <a [routerLink]="['/privacy-policy']" class="text-decoration-none text-white">Terms and Condition &
                    Privacy Policy</a>
                <!--<div class="social-links mt-3">
                    <a href="#" class="btn btn-outline-light btn-social rounded-circle"><i
                            class="fab fa-facebook-f"></i></a>
                    <a href="#" class="btn btn-outline-light btn-social rounded-circle"><i
                            class="fab fa-twitter"></i></a>
                    <a href="#" class="btn btn-outline-light btn-social rounded-circle"><i class="fab fa-instagram"></i></a>
                    <a href="#" class="btn btn-outline-light btn-social rounded-circle"><i
                            class="fab fa-linkedin-in"></i></a>
                </div>-->
            </div>
            <div class="col-lg-4 mb-4 mb-lg-0">
                <!--<h5 class="text-uppercase mb-4">Quick Links</h5>
                <ul class="list-unstyled">
                    <li class="mb-2"><a href="#" class="text-muted">Home</a></li>
                    <li class="mb-2"><a href="#" class="text-muted">Shop</a></li>
                    <li class="mb-2"><a href="#" class="text-muted">Services</a></li>
                    <li class="mb-2"><a href="#" class="text-muted">About Us</a></li>
                    <li class="mb-2"><a href="#" class="text-muted">Contact</a></li>
                </ul>-->
            </div>
            <div class="col-lg-4">
                <h5 class="text-uppercase mb-4">Contact Us</h5>
                <p class="small text-white mb-2">
                    <i class="fas fa-map-marker-alt mr-2"></i>
                    <a href="https://www.google.com/maps?q=20/26,+Subbiah+colony,+K+K+Nagar,+Madurai"
                       target="_blank" class="text-white text-decoration-none">
                        26/20, Subbiah colony, K K Nagar, Madurai - 625 020
                    </a>
                </p>
                <p class="small text-white mb-2">
                    <i class="fas fa-envelope mr-2"></i>
                    <a href="mailto:support@varnik.cloud" class="text-white text-decoration-none">
                        support@varnik.cloud
                    </a>
                </p>
                <p class="small text-white mb-2">
                    <i class="fas fa-phone mr-2"></i>
                    <a href="tel:9787738282" class="text-white text-decoration-none">
                        9787738282
                    </a>
                </p>
                <div class="mt-3">
                    <a href="https://play.google.com/store/apps/details?id=cloud.varnik.mykadai&pcampaignid=web_share"
                       target="_blank" class="btn btn-sm btn-outline-light">
                        <i class="fab fa-google-play fa-lg mr-2"></i>
                        <span>Google Play</span>
                    </a>
                    <a href="#" class="btn btn-sm btn-outline-light ml-2">
                        <i class="fab fa-apple fa-lg mr-2"></i>
                        <span>App Store</span>
                    </a>
                </div>
            </div>
        </div>
        <hr class="my-4 border-secondary">
        <div class="row">
            <div class="col-md-6 text-center text-md-left">
                <p class="small text-white mb-0">&copy; {{currentYear}} My Kadai. All rights reserved.</p>
            </div>
            <div class="col-md-6 text-center text-md-right">
                <p class="small text-white mb-0">Designed & Developed by <a
                        href="https://varnik.cloud/"
                        target="_blank"
                        rel="noopener noreferrer" class="text-white"
                        style="margin: 0"
                >
                    VarNik.Cloud</a
                ></p>
            </div>
        </div>
    </div>
</footer>